import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addNotification as notify } from 'reapop';
import Breadcrumbs from '../../common/Breadcrumbs';
import { importMaterials } from '../../api/materials';

export class MaterialsImport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      file: null,
    }
    this.handleBrowseClick = this.handleBrowseClick.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleImportFile = this.handleImportFile.bind(this);
  }

  handleBrowseClick(e) {
    this.input.click();
  }

  async handleFileUpload(e) {
    const file = e.target.files[0];
    this.setState({ file });
  }

  handleImportFile() {
    const validExts = new Array(".xlsx", ".xls", ".csv");
    const fileName = this.state.file.name;
    const fileExt = fileName.substring(fileName.lastIndexOf('.'));

    if (validExts.indexOf(fileExt) < 0) {
      return this.props.addErrorNotification("Invalid file type, valid file is of " + validExts.toString() + " types.");
    }

    const formData = new FormData();
    formData.append('file', this.state.file);
    this.props.importFile(formData);
  }

  render() {
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/materials', icon: 'shopping_cart', name: 'Materials' },
          { icon: 'publish', name: 'Import from XLS', style: { transform: "rotate(-180deg)" } },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            Materials
          </div>
          <div className="card-block">
            <div className="d-flex flex-column align-items-start">
              <b>Add file</b>
              <div className="d-flex flex-row align-items-center">
                <button className="btn btn-rounded btn-icon ui-btn d-flex align-items-center my-3 mr-2" onClick={this.handleBrowseClick}>
                  <i className="material-icons">attach_file</i>
                  <span className="color-default">Browse</span>
                </button>
                {
                  this.state.file && this.state.file.name
                }
              </div>
              <input
                type="file"
                className="d-none"
                ref={(node) => { this.input = node; }}
                onChange={this.handleFileUpload}
                onClick={(event)=> { 
                  event.target.value = null
                }}
                accept=".csv, .xls, .xlsx"
              />
              <span>Download
                <a href="/assets/templates/Armadillo Groves Order Template.xlsx" target="_blank">
                  &nbsp;template.xls
                </a>
              </span>
              <button disabled={!this.state.file} className="btn btn-success btn-outline d-flex align-items-center mt-4" onClick={this.handleImportFile}>
                <i className="material-icons" style={{ transform: "rotate(-180deg)" }}>publish</i>
                <span className="pl-1">Import</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    importFile: (data) => {
      importMaterials(data)(dispatch);
    },
    addErrorNotification: (message) => {
      dispatch(notify({
        title: 'Import Materials',
        message: message,
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000,
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsImport);



// WEBPACK FOOTER //
// ./src/containers/MaterialsImport/index.js